import { ApolloProvider } from '@apollo/client';
import { useEffect } from 'react';
import { useAppDynamics, logAppDynamicsEvent } from './hooks/useAppDynamics';
import { BrowserRouter } from 'react-router-dom';
import { LOCAL_STORAGE_AUTH_TIME } from './features/common/Common.constants';
import { AuditLogAction, Config } from './features/common/Common.types';
import {
  buildApolloClient,
  clearOidcData,
  getUserInfo,
} from './features/common/Common.utils';
import InactivityController from './features/common/InactivityController';
import Main from './features/common/Main';
import { useLogAction } from './hooks/useLogAction';

interface PostAuthenticationProps {
  config: Config;
}

export default function PostAuthentication({
  config,
}: PostAuthenticationProps) {
  const { logAction } = useLogAction();
  const oidcUser = getUserInfo();
  // After OIDC completes, set identity and push user data
  useAppDynamics(oidcUser?.profile ?? {}, true);

  useEffect(() => {
    clearOidcData();
    if (oidcUser) {
      // Log a user login event (custom user data will be merged by config)
      logAppDynamicsEvent('UserLogin', { message: 'User logged in' });
      const currentAuthTime = oidcUser.profile.auth_time.toString();
      const sessionStorageAuthTime =
        sessionStorage.getItem(LOCAL_STORAGE_AUTH_TIME) ?? '';
      if (
        !sessionStorageAuthTime ||
        currentAuthTime !== sessionStorageAuthTime
      ) {
        sessionStorage.setItem(LOCAL_STORAGE_AUTH_TIME, currentAuthTime);
        logAction({ action: AuditLogAction.Login });
      }
    }
  }, []);
  const client = buildApolloClient(config);

  return (
    <div>
      <ApolloProvider client={client}>
        <InactivityController />
        <BrowserRouter>
          <Main />
        </BrowserRouter>
      </ApolloProvider>
    </div>
  );
}
